<template>
    <div class="MoneyInput">
        <span>$</span>
        <input step="1" min="0" :id="id" :value="value" @input="$emit('input', $event)" type="number" :aria-label="error">
        <span>.00</span>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number,
                required: true
            },
            id: {
                type: Number,
                required: true
            },
            error: {
                type: String,
                default: null
            }
        }
    }
</script>

<style lang="scss" scoped>
    .MoneyInput {
        display: flex;
        align-items: center;
        border-radius: 4px;
        overflow: hidden;
        font-size: 14px;


        span {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            height: 100%;
            padding: 0 7px;
            background-color: #dcdcdc;
            padding-top: 2px;
        }

        input {
            height: 40px;
            min-width: 40px;
            border: none;
            border-top: 1px solid #dcdcdc !important;
            border-bottom: 1px solid #dcdcdc;
            text-align: right;
            padding-right: 5px;
            padding-left: 0;
            margin: 0;
            font-size: 16px;
            -moz-appearance:textfield;
            border-radius: 0;
            outline: none;    
            -webkit-appearance: none;
            -moz-appearance: none;
        }

        input::-webkit-outer-spin-button, 
        input::-webkit-inner-spin-button { 
            margin-left: 2px; 
        } 
    }
</style>
